import { DataResult, DataStream, WidgetSettingsType } from '@thingslog/repositories';
import { DataResultParseStrategy } from './DataResultParseStrategy';
import {
  DataResultParsed,
  DataResultParseDataPoint,
  DataResultParseStream,
} from '../DataResultParsed';
import { formatValueWithUnit } from '../metadata';
import { t } from 'i18next';

export class ApiDevicesBatteryDataResultParseStrategy implements DataResultParseStrategy {
  public parse(dataResult: DataResult, widgetType: WidgetSettingsType): DataResultParsed {
    const parsed: DataResultParsed = {
      dataStreams: [],
      xAxis: {
        show: true,
        dataKey: widgetType === 'table' ? 'deviceLabel' : 'deviceNumber',
        name: t('devices', 'Devices'),
        formatter: (value: string) => value,
      },
      yAxis: {
        show: true,
        formatter: (value: number) => formatValueWithUnit(value, '%'),
      },
      legend: {
        show: true,
      },
      tooltip: {
        labelFormatter: (value: string | number, dataPoint?: DataResultParseDataPoint): string => {
          return dataPoint?.deviceName ? `${value} - ${dataPoint.deviceName}` : String(value);
        },
      },
    };

    const dataStream: DataResultParseStream = {
      data: [],
      visualization: [
        {
          dataKey: 'level',
          fill: '#82ca9d',
          innerRadius: 70,
          outerRadius: 90,
          name: t('dashboard_battery_level', 'Battery level'),
          nameKey: 'deviceLabel',
          unit: '%',
        },
      ],
    };

    dataResult.streams.forEach((stream: DataStream) => {
      if (stream.type !== 'series') return;
      if (stream.data.length !== 1) return;
      const level = stream.data[0];
      const deviceNumber = stream.metaData.deviceNumber ?? '';

      dataStream.data.push({
        ...stream.metaData,
        deviceLabel: stream.metaData.deviceName
          ? `${deviceNumber} - ${stream.metaData.deviceName}`
          : deviceNumber,
        level,
      });
    });

    parsed.dataStreams.push(dataStream);

    return parsed;
  }
}
